// imports
import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'

// components
import { Button, Footer } from '@bosch/react-frok'

// utils
import useWindowSize from '@/hooks/useWindowSize'
import { RootState } from '@/utils/store/store'

// styles
import './Footer.scss'

const BoschFooter = ({show}: {show?: boolean}) => {
    const [isExtendedDisclaimer, setIsExtendedDisclaimer] = useState(false)
    const { hideDisclaimer } = useSelector((state: RootState) => state.application)


    const { isMobile } = useWindowSize()
    const { t } = useTranslation()

    const toggleDisclaimer = () => {
        setIsExtendedDisclaimer(prev => !prev)
    }

    const smallMobileDisclaimer = () => {
        return (
            <div className="mobile-disclaimer small-mobile-disclaimer">
                <div className="disclaimer-child disclaimer-text">
                    {t('general:disclaimer')}
                </div>
            </div>
        )
    }

    const extendedMobileDisclaimer = () => {
        return (
            <div className="mobile-disclaimer extended-mobile-disclaimer">
                <div className='disclaimer-text'>
                    {t('general:disclaimer')}
                </div>
                <div className='disclaimer-button'>
                    <Button mode='integrated' icon="down" onClick={toggleDisclaimer} />
                </div>
            </div>
        )
    }

    const disclaimer = () => {
        let disclaimer = <div> {t('general:disclaimer')} </div>
        if (isMobile) {
            if (!isExtendedDisclaimer) {
                disclaimer = smallMobileDisclaimer()
            }
            if (isExtendedDisclaimer) {
                disclaimer = extendedMobileDisclaimer()
            }
        }
        return disclaimer
    }

    return (
        <>
            {(show || !hideDisclaimer) &&
                <div className="footer-wrapper">
                    <Footer variation='minimal' copyright={disclaimer()}></Footer>
                </div>}
        </>
    )
}

export default BoschFooter
